import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './lib/auth';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { AgentChatPage } from './pages/AgentChatPage';
import { ReportsPage } from './pages/ReportsPage';
import { RegistryPage } from './pages/RegistryPage';
import { CapaPage } from './pages/CapaPage';
import { AuditPage } from './pages/AuditPage';
import { YggPage } from './pages/YggPage';
import { UsersPage } from './pages/UsersPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="/agent" element={<AgentChatPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/registry" element={<RegistryPage />} />
        <Route path="/capa" element={<CapaPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/ygg" element={<YggPage />} />
        <Route path="/users" element={<UsersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
